import { internalActions } from "@/action/internalActions";
import { isOffScreen, offScreenCoord, relativeFromViewport } from "@/math/coordinate-utils";
import { distance2 } from "@/math/coordinates";
import { pointerPosInterval } from "@/model/Settings";
import type { RelativeCoordinate } from "@/model/coordinates";
import { initViewportCoord } from "@/model/coordinates";
import { useBoardStore } from "@/store/board";
import { usePointerStore } from "@/store/pointer";
import { mousePointer } from "@/utils/dom/pointer";

let trailTimeout = 0;
let lastPos = initViewportCoord();

export function trail(start: boolean) {
  clearTimeout(trailTimeout);
  if (start) {
    sendPos();
  } else {
    doSendPos(offScreenCoord());
  }
}

function sendPos() {
  if (distance2(mousePointer, lastPos) > 25) {
    doSendPos(isOffScreen(mousePointer) ? offScreenCoord() : relativeFromViewport(mousePointer));
    lastPos = mousePointer;
  }
  trailTimeout = window.setTimeout(sendPos, pointerPosInterval);
}

function doSendPos(p: RelativeCoordinate) {
  internalActions.pointerPos(useBoardStore().currentBoard().id, p);
  usePointerStore().set({ pos: p });
}
